(() => {
  if (window.__cardsGridHubspotReady) return;
  window.__cardsGridHubspotReady = true;

  const cardsSelector = '[data-hubspot-card]';

  function ownerSection(card) {
    return card.closest('[id^="shopify-section-"]') || card.closest('section') || card.parentElement;
  }

  function getPanel(section) {
    let panel = Array.from(section.children).find(el => el.classList.contains('cards-grid__hubspot-panel'));
    if (panel) return panel;

    panel = document.createElement('div');
    panel.className = 'cards-grid__hubspot-panel';
    panel.hidden = true;
    panel.innerHTML = `
      <button type="button" class="cards-grid__hubspot-close" aria-label="Close form">
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 5 19 19M19 5 5 19"/></svg>
      </button>
      <div class="cards-grid__hubspot-intro"></div>
      <div class="cards-grid__hubspot-form"></div>
    `;
    section.appendChild(panel);
    return panel;
  }

  function openCardForm(card) {
    const source = card.querySelector('[data-hubspot-embed-source]');
    if (!source || !source.value.trim()) return;

    const panel = getPanel(ownerSection(card));
    const intro = panel.querySelector('.cards-grid__hubspot-intro');
    const target = panel.querySelector('.cards-grid__hubspot-form');
    const template = card.querySelector('template[data-hubspot-form-content]');
    intro.replaceChildren();
    if (template) intro.appendChild(template.content.cloneNode(true));

    // Embedded HTML stored in the theme editor: parse safely and copy only
    // HubSpot's expected frame, plus its HubSpot loader URL.
    const doc = new DOMParser().parseFromString(source.value, 'text/html');
    const originalFrame = doc.querySelector('.hs-form-frame');
    const loader = Array.from(doc.querySelectorAll('script[src]'))
        .find(el => /^https:\/\/js-[a-z0-9-]+\.hsforms\.net\/forms\/embed\/[0-9]+\.js(?:\?.*)?$/i.test(el.src));

    target.replaceChildren();
    if (!originalFrame || !loader) {
      const warning = document.createElement('p');
      warning.textContent = 'HubSpot embed code is incomplete. Add its script and hs-form-frame element.';
      target.appendChild(warning);
    } else {
      const frame = document.createElement('div');
      frame.className = 'hs-form-frame';
      for (const attribute of ['data-region', 'data-form-id', 'data-portal-id']) {
        if (originalFrame.hasAttribute(attribute)) {
          frame.setAttribute(attribute, originalFrame.getAttribute(attribute));
        }
      }
      target.appendChild(frame);
      // Reinsert a script element each time: an existing external script tag
      // won't automatically re-render forms when new frames are added.
      const script = document.createElement('script');
      script.src = loader.src;
      script.async = true;
      target.appendChild(script);
    }

    panel.hidden = false;
    requestAnimationFrame(() => panel.scrollIntoView({ behavior: 'smooth', block: 'start' }));
  }

  function enableFormButtons(root = document) {
    const cards = [];
    if (root.matches?.(cardsSelector)) cards.push(root);
    root.querySelectorAll?.(cardsSelector).forEach(card => cards.push(card));
    cards.forEach(card => {
      const source = card.querySelector('[data-hubspot-embed-source]');
      if (!source?.value.trim()) return;
      card.querySelectorAll('.cards-grid__item-inner button, .cards-grid__item-inner a[aria-disabled], .cards-grid__item-inner [role="button"]').forEach(button => {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
        button.removeAttribute('inert');
      });
    });
  }

  // Also covers cards replaced dynamically by Horizon / Theme Editor.
  let updating = false;
  const observer = new MutationObserver(() => {
    if (updating) return;
    updating = true;
    observer.disconnect();
    enableFormButtons();
    observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    updating = false;
  });
  enableFormButtons();
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });

  document.addEventListener('click', (event) => {
    const close = event.target.closest('.cards-grid__hubspot-close');
    if (close) {
      const panel = close.closest('.cards-grid__hubspot-panel');
      panel.hidden = true;
      panel.querySelector('.cards-grid__hubspot-form').replaceChildren();
      return;
    }

    const trigger = event.target.closest('button, a, [role="button"]');
    if (!trigger || trigger.closest('.cards-grid__hubspot-panel')) return;

    const card = trigger.closest(cardsSelector);
    if (!card || !card.querySelector('[data-hubspot-embed-source]')) return;

    // Don't hijack the invisible overlay linking the entire card.
    if (trigger.matches('.cards-grid__item-link')) return;

    event.preventDefault();
    event.stopPropagation();
    openCardForm(card);
  }, true);
})();
